import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalEditorRotateIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-editor-rotate"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M17.5 10V6.667a3.333 3.333 0 0 0-3.333-3.334h-3.334m2.084 2.084-2.084-2.084 2.084-2.083M4.167 17.5H10c.92 0 1.667-.746 1.667-1.667V10c0-.92-.747-1.667-1.667-1.667H4.167C3.247 8.333 2.5 9.08 2.5 10v5.833c0 .92.746 1.667 1.667 1.667"
        />
    </svg>
);
const Memo = memo(ImageModalEditorRotateIcon);
export default Memo;
